import {Component, OnInit} from '@angular/core';
import {
  PictureAnnotationWidgetComponent
} from '../../widgets/picture-annotation-widget/picture-annotation-widget.component';
import {ActivatedRoute, Router} from '@angular/router';
import {DocumentDto} from '../../../api/api-client';
import {AddDocumentRoutingInfo} from '../../../models/add-document-routing-info';
import {FeedbackDataService} from '../../../services/feedback-data.service';

@Component({
  selector: 'app-picture-drawer',
  imports: [PictureAnnotationWidgetComponent],
  templateUrl: './picture-drawer.component.html',
  styleUrl: './picture-drawer.component.scss'
})
export class PictureDrawerComponent implements OnInit {

  imageData!: DocumentDto;
  routingData!: AddDocumentRoutingInfo;

  constructor(private router: Router, private feedbackService: FeedbackDataService) {
    this.imageData= <DocumentDto>this.router.currentNavigation()?.extras.state?.['addedDocument'];
    this.routingData= <AddDocumentRoutingInfo>this.router.currentNavigation()?.extras.state?.['routingData'];
    this.feedbackService.feedbackData=null;
  }
  ngOnInit(): void {

  }



}
